import * as Sentry from '@sentry/react';
import { filterContext } from './sentryContextSanitizer';
import { isSentryRuntimeEnabled } from './sentryConfig';

export function reportClientError(error, context = {}) {
  if (!error || !isSentryRuntimeEnabled()) {
    return;
  }

  try {
    Sentry.withScope((scope) => {
      const safeContext = filterContext(context);
      Object.entries(safeContext).forEach(([key, value]) => {
        scope.setExtra(key, value);
      });
      if (safeContext.operation) {
        scope.setTag('operation', String(safeContext.operation));
      }
      Sentry.captureException(error);
    });
  } catch (_error) {
    // App must keep working if Sentry is unavailable.
  }
}
